import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { adminApi } from "../../services/api";
import AdminPanel from "../../components/admin/AdminPanel";
import AdminTable from "../../components/admin/AdminTable";
import AdminFilter from "../../components/admin/AdminFilter";
import useAdminData from "../../components/admin/useAdminData";
import { unwrap, params, formatDate } from "../../components/admin/adminFormat";
import { ValueUnavailable } from "../../components/admin/AdminUnavailable";
import Button from "../../components/Button";

const PAGE_SIZE = 20;

// "T00:00:00.000Z" / "T23:59:59.999Z" : un input date HTML n'a pas d'heure,
// l'API attend un Instant - on borne explicitement le jour choisi, sans
// jamais inventer une heure precise que l'utilisateur n'a pas donnee.
const toInstant = (value, endOfDay) => (value ? new Date(`${value}T${endOfDay ? "23:59:59.999" : "00:00:00.000"}Z`).toISOString() : undefined);

export default function Audit() {
  const { t } = useTranslation();
  const { locale } = useOutletContext();
  const [form, setForm] = useState({ entityType: "", action: "", actorId: "", from: "", to: "" });
  const [query, setQuery] = useState({ page: 0 });
  const { data, loading } = useAdminData(async () => unwrap(await adminApi.getAuditLog(query)), [query]);

  const submit = () => setQuery(params({
    entityType: form.entityType, action: form.action, actorId: form.actorId,
    from: toInstant(form.from, false), to: toInstant(form.to, true), page: 0,
  }));

  const goToPage = (page) => setQuery({ ...query, page });

  return (
    <>
      <AdminFilter t={t} form={form} setForm={setForm} fields={["entityType", "action", "actorId", "from", "to"]} submit={submit} />
      <AdminPanel>
        {loading ? t("common.loading") : (
          <>
            <AdminTable
              t={t}
              headers={[t("admin.date"), t("admin.action"), t("admin.entity_type"), t("admin.entity_id"), t("admin.actor"), t("admin.actor_role"), t("admin.country"), t("admin.ip_address"), t("admin.details")]}
              rows={(data?.content || []).map((item) => [
                formatDate(item.createdAt, locale),
                item.action,
                item.entityType,
                item.entityId,
                item.actorId,
                item.actorRole,
                item.countryCode || <ValueUnavailable t={t} />,
                item.ipAddress || "—",
                item.details || "—",
              ])}
            />
            {data && data.totalPages > 1 && (
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginTop: 14 }}>
                <Button size="sm" variant="ghost" disabled={data.page <= 0} onClick={() => goToPage(data.page - 1)}>{t("admin.previous")}</Button>
                <span>{t("admin.page_info", { page: data.page + 1, total: data.totalPages })}</span>
                <Button size="sm" variant="ghost" disabled={data.page + 1 >= data.totalPages} onClick={() => goToPage(data.page + 1)}>{t("admin.next")}</Button>
              </div>
            )}
          </>
        )}
      </AdminPanel>
    </>
  );
}
